import Head from 'next/head';
import { useRouter } from 'next/router';
import { isItUndefined, replaceGlobalMetrics } from '../../util/DataUtil';
import { useSelector } from 'react-redux';
import React from 'react';

export default function TemplateTitle({
  data,
  lang,
  color,
  read,
  global,
  itemCount,
  contentType,
  blockType,
  datetime,
}) {
  const url = useSelector((state) => state?.host?.host);
  const { asPath } = useRouter();
  const alias = asPath.substring(1);
  const timestamp = new Date().getTime();

  const renderArticlePublishDate = (stringDate) => {
    if (!stringDate) {
      return null;
    }
    const date = new Date(stringDate);
    const day = date.getDate();
    const suffix =
      day % 10 === 1 && day !== 11
        ? 'st'
        : day % 10 === 2 && day !== 12
          ? 'nd'
          : day % 10 === 3 && day !== 13
            ? 'rd'
            : 'th';
    const month = date.toLocaleString('en-US', { month: 'long' });
    const year = date.getFullYear();

    return (
      <div className={'article-publish-date-container'}>
        <div className={'article-publish-date'}>
          {' '}
          {month} {day}
          {suffix}, {year}
        </div>
        <div className={'horizontal-line'}></div>
      </div>
    );
  };

  return (
    <div>
      <div
        style={{ borderTop: '2px solid ' + color, position: 'relative' }}
        className={
          itemCount
            ? `template-title template-title-${itemCount}`
            : 'template-title'
        }
      >
        <Head>
          <meta
            name="twitter:title"
            content={data ? data?.field_template_title[0]?.value : ''}
          />
          <meta
            name="og:title"
            content={data ? data?.field_template_title[0]?.value : ''}
          />
        </Head>
        <div className={'top'}>
          <span>
            {blockType ? blockType[0]?.name : ''}
            {read && read[0]?.value && (
              <span className={'read'}>, {read[0]?.value}</span>
            )}
          </span>
          <h1 className={'titleh'}>
            {global
              ? replaceGlobalMetrics(
                  data?.field_template_title[0]?.value,
                  global
                )
              : ''}
          </h1>
          {contentType === 'press_release' && datetime && (
            <span className="datetime">{datetime ? datetime : ''}</span>
          )}
        </div>
        {isItUndefined(data?.field_hide_social_icons) !== '1' ? (
          <div className={'social'}>
            <a
              className={'a-template-title-link'}
              target="_blank"
              href={`https://twitter.com/share?text=${data?.field_template_title[0]?.value}&url=${url + '/' + alias}?t=${timestamp}&hashtags=digitalreality`}
              rel="noopener noreferrer"
            >
              <img alt="twitter" src={'/images/x.svg'} />
            </a>
            <a
              className={'a-template-title-link'}
              target="_blank"
              href={`https://www.linkedin.com/shareArticle?mini=true&url=${url + '/' + alias}?t=${timestamp}&title=${data?.field_template_title[0]?.value}&source=Digital reality?latest`}
            >
              <img alt="linkedin" src={'/images/linkedin.svg'} />
            </a>
          </div>
        ) : (
          <></>
        )}
      </div>
      {(contentType === 'content_template' ||
        contentType === 'gated_template' ||
        contentType === 'non_gated_template' ||
        contentType === 'case_study_dynamic') &&
        renderArticlePublishDate(datetime)}
    </div>
  );
}
